import React from 'react';
import { css } from '@emotion/react';

import Settings from '$/components/ui/Settings';
import { usePlanPageContext } from '../PlanPage';

export const AvailableAddOns: React.FC = () => {
  const { availableAddOns } = usePlanPageContext();

  if (availableAddOns.length === 0) return null;

  return (
    <Settings.Section id='addons'>
      <Settings.Subsection>
        <Settings.Title>Available add-ons</Settings.Title>
        <Settings.Description>
          Add-ons increase the power of your eWebinar subscription to meet the needs of your
          business.{' '}
          <a target='blank' href='https://ewebinar.com/help/subscription-add-ons'>
            Learn more
          </a>
        </Settings.Description>
        {availableAddOns.length === 0 && (
          <Settings.Description className='text-center'>
            No more available add-on
          </Settings.Description>
        )}
        <div
          className='flex flex-row flex-wrap mt-3'
          css={css`
            margin-left: -0.5rem;
            margin-right: -0.5rem;
          `}
        >
          {availableAddOns.map((AddOn) => (
            <AddOn.CardComponent key={AddOn.type} />
          ))}
        </div>
      </Settings.Subsection>
    </Settings.Section>
  );
};
